<template>
	<div><span class="biaoti">微信支付参数</span>
		<el-collapse v-model="activeNames" @change="handleChange">
			<el-collapse-item :title="l.biaoti" :name="l.name" v-for="l in lie">
				<el-form label-width="80px" :model="formLabelAlign" style="margin-top: 20px">
					<el-form-item :label="l.ming" label-width="180px">
						<el-radio v-model="radio" label="1" style="margin-left: 12px;">开启</el-radio>
						<el-radio v-model="radio" label="2">关闭</el-radio>
						<el-form-item class="tishi" style="margin-left: 8px;">{{l.tishi}}</el-form-item>
					</el-form-item>
				</el-form>
			</el-collapse-item>
			<!-- 支付宝支付 -->
			<el-collapse-item title="设置支付宝无线支付" name="3">
				<el-form label-width="80px" :model="formLabelAlign" style="margin-top: 20px">
					<el-form-item label="支付宝无线支付" label-width="200px">
						<el-tag type="success">您的支付宝账号必须支持手机网页即时到账接口, 才能使用手机支付功能,
							<el-link :underline="false" type="info" closable>申请及详情请查看这里</el-link>
						</el-tag>
					</el-form-item>
					<el-form-item label-width="180px">
						<el-radio v-model="radio" label="1" style="margin-left: 12px;">开启</el-radio>
						<el-radio v-model="radio" label="2">关闭</el-radio>
					</el-form-item>
					<el-form-item label="AppId" label-width="200px">
						<el-input v-model="input" placeholder="请输入AppId"></el-input>
					</el-form-item>
					<el-form-item label="支付公钥" label-width="200px">
						<el-input v-model="input" placeholder="请输入AppId"></el-input>
						<el-form-item class="tishi" style="color: #737373;">支付宝提供公钥</el-form-item>
					</el-form-item>
					<el-form-item label="(RSA2)私密钥" label-width="200px">
						<el-input type="textarea" :autosize="{ minRows: 8, maxRows: 12}" placeholder="请输入内容" v-model="textarea">
						</el-input>
						<el-form-item class="tishi" style="color: #737373;">APP密钥:生成RSA密钥,开发者私钥;此处有APP用户填写</el-form-item>
					</el-form-item>
				</el-form>
			</el-collapse-item>
			<!-- 微信支付 -->
			<el-collapse-item title="设置微信支付开关" name="4">
				<el-form label-width="80px" :model="formLabelAlign" style="margin-top: 20px">
					<!-- <el-form-item label="" class="touu" label-width="160px"></el-form-item> -->
					<el-form-item label="支付宝无线支付" label-width="200px">
						<el-tag type="success">你必须向微信公众平台提交企业信息以及银行账户资料，审核通过并签约后才能使用微信支付功能,
							<el-link :underline="false" type="info" closable>申请及详情请查看这里.</el-link>
						</el-tag>
						<el-tag type="success">支付授权目录一: https://limitao.zhiwi.cn/h5/</el-tag>
					</el-form-item>
					<el-form-item label-width="180px">
						<el-radio v-model="radio" label="1" style="margin-left: 12px;">开启</el-radio>
						<el-radio v-model="radio" label="2">关闭</el-radio>
						<el-form-item class="tishi" style="color: #737373;margin-left: 10px;">是否使用微信支付</el-form-item>
					</el-form-item>
					<el-form-item label="身份标识(appId)" label-width="200px">
						<el-input v-model="input" placeholder="请输入AppId"></el-input>
						<el-form-item class="tishi" style="color: #737373;margin-left: 10px;">
							公众号身份标识 <el-link :underline="false" type="primary">请通过修改公众号信息来保存</el-link>
						</el-form-item>
					</el-form-item>
					<el-form-item label="身份密钥(appSecret)" label-width="200px">
						<el-input v-model="input" placeholder="请输入AppId"></el-input>
						<el-form-item class="tishi" style="color: #737373;">
							公众平台API(参考文档API 接口部分)的权限获取所需密钥Key
							<el-link :underline="false" type="primary">请通过修改公众号信息来保存</el-link>
						</el-form-item>
					</el-form-item>
					<el-form-item label="微信支付商户号(MchId)" label-width="200px">
						<el-input v-model="input" placeholder="请输入AppId"></el-input>
						<el-form-item class="tishi" style="color: #737373;">
							公众号支付请求中用于加密的密钥Key</el-link>
						</el-form-item>
					</el-form-item>
					<el-form-item label="商户支付密钥(API密钥)" label-width="200px">
						<el-input v-model="input" placeholder="请输入AppId">
							<template slot="append">生成新的</template>
						</el-input>
						<el-form-item class="tishi" style="color: #737373;">
							此值需要手动在腾讯商户后台API密钥保持一致。
							<el-link :underline="false" type="primary">查看设置教程</el-link>
						</el-form-item>
					</el-form-item>
					<el-form-item label="CERT证书文件" label-width="200px">
						<Shangtu @shanghu="Shanghu" :shuliang='1'></Shangtu>
						<el-tag type="success" effect="dark" size="samll" class="yishangchuan">已上传</el-tag>
						<el-link :underline="false" type="primary">下载证书 cert.zip 中的 apiclient_cert.pem 文件</el-link>
					</el-form-item>
					</el-form-item>
					<el-form-item label="KEY密钥文件" label-width="200px">
						<Shangtu @shanghu="Shanghu" :shuliang='1'></Shangtu>
						<el-tag type="success" effect="dark" size="samll" class="yishangchuan">已上传</el-tag>
						<el-link :underline="false" type="primary">下载证书 cert.zip 中的 apiclient_key.pem 文件</el-link>
					</el-form-item>
					</el-form-item>
					<!-- <el-form-item label="(RSA2)私密钥" label-width="200px">
				<el-input type="textarea" :autosize="{ minRows: 8, maxRows: 12}" placeholder="请输入内容" v-model="textarea">
				</el-input>
				<el-form-item class="tishi" style="color: #737373;">APP密钥:生成RSA密钥,开发者私钥;此处有APP用户填写</el-form-item>
			</el-form-item> -->
				</el-form>
			</el-collapse-item>
			<!-- APP微信支付开关 -->
			<el-collapse-item title="设置APP微信支付开关" name="5" >
				<el-form label-width="80px" :model="formLabelAlign " style="margin-top: 20px">
					<el-form-item label-width="180px" label="微信支付">
						<el-radio v-model="radio" label="1" style="margin-left: 12px;">开启</el-radio>
						<el-radio v-model="radio" label="2">关闭</el-radio>
						<el-form-item class="tishi" style="color: #737373;margin-left: 10px;">是否使用微信支付</el-form-item>
					</el-form-item>
					<el-form-item label="版本号(version)" label-width="200px">
						<el-input v-model="input" placeholder="请输入AppId"></el-input>
						<el-form-item class="tishi" style="color: #737373;margin-left: 10px;">
							公众号身份标识 <el-link :underline="false" type="primary">请通过修改公众号信息来保存</el-link>
						</el-form-item>
					</el-form-item>
					<el-form-item label="身份标识(appId)" label-width="200px">
						<el-input v-model="input" placeholder="请输入AppId"></el-input>
						<el-form-item class="tishi" style="color: #737373;margin-left: 10px;">
							公众号身份标识 <el-link :underline="false" type="primary">请通过修改公众号信息来保存</el-link>
						</el-form-item>
					</el-form-item>
					<el-form-item label="身份密钥(appSecret)" label-width="200px">
						<el-input v-model="input" placeholder="请输入AppId"></el-input>
						<el-form-item class="tishi" style="color: #737373;">
							公众平台API(参考文档API 接口部分)的权限获取所需密钥Key
							<el-link :underline="false" type="primary">请通过修改公众号信息来保存</el-link>
						</el-form-item>
					</el-form-item>
					<el-form-item label="微信支付商户号(MchId)" label-width="200px">
						<el-input v-model="input" placeholder="请输入AppId"></el-input>
						<el-form-item class="tishi" style="color: #737373;">
							公众号支付请求中用于加密的密钥Key</el-link>
						</el-form-item>
					</el-form-item>
					<el-form-item label="商户支付密钥(API密钥)" label-width="200px">
						<el-input v-model="input" placeholder="请输入AppId">
							<template slot="append">生成新的</template>
						</el-input>
						<el-form-item class="tishi" style="color: #737373;">
							此值需要手动在腾讯商户后台API密钥保持一致。
							<el-link :underline="false" type="primary">查看设置教程</el-link>
						</el-form-item>
					</el-form-item>
					<el-form-item label="CERT证书文件" label-width="200px">
						<Shangtu @shanghu="Shanghu" :shuliang='1'></Shangtu>
						<el-tag type="success" effect="dark" size="samll" class="yishangchuan">已上传</el-tag>
						<el-link :underline="false" type="primary">下载证书 cert.zip 中的 apiclient_cert.pem 文件</el-link>
					</el-form-item>
					</el-form-item>
					<el-form-item label="KEY密钥文件" label-width="200px">
						<Shangtu @shanghu="Shanghu" :shuliang='1'></Shangtu>
						<el-tag type="success" effect="dark" size="samll" class="yishangchuan">已上传</el-tag>
						<el-link :underline="false" type="primary">下载证书 cert.zip 中的 apiclient_key.pem 文件</el-link>
					</el-form-item>
					</el-form-item>
				</el-form>
			</el-collapse-item>
			<!-- 银联/百度钱包 -->
			<el-collapse-item :title="l.biaoti" :name="l.name" v-for="l in lies">
				<el-form label-width="80px" :model="formLabelAlign" style="margin-top: 20px">
					<el-form-item :label="l.ming" label-width="180px">
						<el-radio v-model="radio" label="1" style="margin-left: 12px;">开启</el-radio>
						<el-radio v-model="radio" label="2">关闭</el-radio>
						<el-form-item class="tishi" style="margin-left: 8px;">{{l.tishi}}</el-form-item>
					</el-form-item>
				</el-form>
			</el-collapse-item>
		</el-collapse>
		<el-button type="danger" size="small" style="margin-top: 20px;padding: 10px 32px;">提交</el-button>
	</div>

</template>

<script>
	import Shangtu from '../../zujian/Shangtu.vue'
	export default {
		data() {
			return {
				lie: [{
					biaoti: '设置货到支付开关',
					ming: '货到支付',
					tishi: '是否支持货到付款',
					name: "1"
				}, {
					biaoti: '设置货到支付开关',
					ming: '余额支付',
					tishi: '是否使用粉丝中心的余额直接支付',
					name: "2"
				}],
				lies: [{
					biaoti: '设置银联支付开关',
					ming: '银联支付',
					tishi: '是否使用银联支付',
					name: "6"
				}, {
					biaoti: '设置百度钱包支付开关',
					ming: '百度钱包支付',
					tishi: '是否使用百度钱包支付',
					name: "7"
				}],
				textarea: '',
				input: '',
				radio: 1
			};
		},
		components: {
			Shangtu
		},

		methods: {
			Shanghu: function(e) {
				console.log(e)
			},
		}
	}
</script>

<style>
	.touu {
		background: #f7fafa;
		/* text-indent: 5px; */
	}

	.biaoti {
		display: block;
		width: 100%;
		text-indent: 10px;
		margin-bottom: 16px;
		font-size: 20px;
		color: #788188;
	}

	.yishangchuan {
		margin-top: 18px;
		margin-right: 10px;
	}

	/* el-form-item{
		margin-right: 30px !important;
	} */
	.el-collapse-item__header {
		text-indent: 30px;
	}

	.el-collapse-item__header {
		background: #f7fafa;
		/* box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04) */
	}
</style>
